const languages = [
  'en-US',
  'de-DE'
];

export default languages;
